import { render, staticRenderFns } from "./dropshippingFull.vue?vue&type=template&id=076a0b6a"
import script from "./dropshippingFull.vue?vue&type=script&lang=js"
export * from "./dropshippingFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports